const selectPermissionIssueStatus = (state) => state.permission.issueStatus;
export const selectDoesNotUserCase = (state) =>
  state.permission.isDoesNotUserCase;
export const selectIsManager = (state) => state.permission.isManager;

export default selectPermissionIssueStatus;
